import Component from '../Component';
import { CardType } from '../../Prototype/Level/Card/CardType';
import { CardState } from "../../Prototype/Level/Card/CardState";

export const DEFAULT_CARD_SCALE = 1;

export default class CardComponent extends Component {
    public type: CardType = undefined;
    public value?: number = undefined;
    public random?: boolean = undefined;
    public depth?: number = undefined;
    public sequence?: number = undefined;
    public faceUp: boolean = false;
    public x: number = 0;
    public y: number = 0;
    public rotation: number = 0;
    public attempts: number = 0;
    public currentState: CardState = CardState.UNKNOWN;
    public flipping: boolean = false;
    public animating: boolean = false;
    public skipStackAlign: boolean = false;
}
